import React from 'react'
import ModalConsumer from './ModalConsumer'

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, props, hideModal }) =>
      Component ? <Component {...props} onClose={hideModal}/> : null
    }
  </ModalConsumer>
)

export default ModalRoot